// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1VT40","colBig":"styles_colBig__3Ffuh","colSmall":"styles_colSmall__90vo7"};